import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { ISubjectMobile } from "../../../Pages/SubjectMobile/ISubjectMobile";

export const EditSubjectMobileSlice = createSlice({
  name: "EditSubjectMobileSlice",
  initialState: {} as IReduxState<ISubjectMobile>,
  reducers: {
    EditSubjectMobile: (state, _: PayloadAction<ISubjectMobile>) => {
      state.isLoading = true;
    },
    successEditSubjectMobile: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureEditSubjectMobile: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearEditSubjectMobileResponse: (state) => {
      state.data = {};
    },
  },
});

export const {
  EditSubjectMobile,
  failureEditSubjectMobile,
  successEditSubjectMobile,
  clearEditSubjectMobileResponse,
} = EditSubjectMobileSlice.actions;

export default EditSubjectMobileSlice.reducer;
